module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Icon_EmptyState.daceaa00.svg";